<div class="lock">
    <mat-icon fontSet="material-symbols-outlined" inline>lock</mat-icon>
</div>

<div class="text">
    <h4>Sign in to view price</h4>
    <p>Login to access pricing and complete your purchase.</p>
</div>
<div class="actions">
    <a matButton="filled" href="/login">Sign In to View Price</a>
    <a matButton="outlined" href="/signup">Create an Account</a>
</div>